import { slices } from "@/constants/sliceNames";
import { Alert } from "@/entities/Alert";
import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../../axios/defaultAxios";
import { errorMessage, successMessage } from "../../actions/messages.actions";

const ENDPOINT = "email-alert-subscriber";

/******** List Alerts  **********/
export const requestAlerts = createAsyncThunk(
  `${slices.alerts}/requestAlerts`,
  async (filter, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}?${new URLSearchParams(filter).toString()}`);
      const { data, page_limit, records_count, total_pages, current_page } = response.data.data;
      return {
        alerts: data.map(Alert.fromApi),
        pageLimit: page_limit,
        recordsCount: records_count,
        totalPages: total_pages,
        currentPage: current_page,
      };
    } catch (error) {
      console.log(error.response);
      dispatch(errorMessage(error.response.data.message || error.response.data));
      return rejectWithValue(error);
    }
  }
);

export const requestAlertsStatus = {
  [requestAlerts.fulfilled]: (state, action) => {
    state.loading = false;
    state.alerts = action.payload.alerts;
    state.pageLimit = action.payload.pageLimit;
    state.currentPage = action.payload.currentPage;
    state.totalPages = action.payload.totalPages;
    state.recordsCount = action.payload.recordsCount;
  },
  [requestAlerts.pending]: (state, action) => {
    state.loading = true;
  },
  [requestAlerts.rejected]: (state, action) => {
    state.error = action.payload.error;
    state.loading = false;
  },
};

/******** Delete Alert  **********/

export const deleteAlert = createAsyncThunk(
  `${slices.alerts}/deleteAlert`,
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${ENDPOINT}/${id}`);
      const { data: message } = response.data;
      dispatch(successMessage(message));
      return {
        id,
        message,
      };
    } catch (error) {
      console.log(error.response);
      dispatch(errorMessage(error.response.data.message || error.response.data));
      return rejectWithValue(error);
    }
  }
);

export const deleteAlertStatus = {
  [deleteAlert.fulfilled]: (state, action) => {
    state.alerts = state.alerts.filter((alert) => alert.id !== action.payload.id);
  },
  [deleteAlert.pending]: (state, action) => {},
  [deleteAlert.rejected]: (state, action) => {
    state.error = action.payload.error;
  },
};

/*********************** Create new alert ***********************/
export const createAlert = createAsyncThunk(`${slices.alerts}/createAlert`, async function (
  data,
  { rejectWithValue, dispatch }
) {
  try {
    const response = await axios.post(`${ENDPOINT}`, data);
    if (response.status === 200) {
      dispatch(successMessage(response.data.message));
      return response.data.data;
    }
  } catch (error) {
    dispatch(errorMessage(error.response.data.error));
    return rejectWithValue(error);
  }
});

export const createAlertStatuses = {
  [createAlert.fulfilled]: (state, action) => {
    state.loading = false;
  },
  [createAlert.pending]: (state, action) => {
    state.loading = true;
  },
  [createAlert.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload.error;
  },
};

/***********************  Get alert ***********************/
export const getAlert = createAsyncThunk(`${slices.alerts}/getAlert`, async function (
  id,
  { rejectWithValue, dispatch }
) {
  try {
    const response = await axios.get(`${ENDPOINT}/${id}`);
    if (response.status === 200) {
      const { data } = response.data;
      return {
        alert: Alert.fromApi(data),
      };
    }
  } catch (error) {
    dispatch(errorMessage(error.response.data.error));
    return rejectWithValue(error);
  }
});

export const getAlertStatuses = {
  [getAlert.fulfilled]: (state, action) => {
    state.loading = false;
    state.alert = action.payload.alert;
  },
  [getAlert.pending]: (state, action) => {
    state.loading = true;
  },
  [getAlert.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload.error;
  },
};

/***********************  Update alert ***********************/
export const updateAlert = createAsyncThunk(`${slices.alerts}/updateAlert`, async function (
  { id, data },
  { rejectWithValue, dispatch }
) {
  try {
    const response = await axios.put(`${ENDPOINT}/${id}`, data);
    if (response.status === 200) {
      dispatch(successMessage(response.data.message));
      return response.data.data;
    }
  } catch (error) {
    dispatch(errorMessage(error.response.data.error));
    return rejectWithValue(error);
  }
});

export const updateAlertStatuses = {
  [updateAlert.fulfilled]: (state, action) => {
    state.loading = false;
  },
  [updateAlert.pending]: (state, action) => {
    state.loading = true;
  },
  [updateAlert.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload.error;
  },
};
